export default __webpack_public_path__ + "locales/ar-SA/SharingPanel.json?hash=3edc0f7d116ab321f182d1d90ce75a87";